import React, { useState } from 'react';

const books = [
  {
    title: 'پانی ہی پانی',
    author: 'روی پرانجے',
    src: 'https://archive.org/embed/pani-hee-pani-ravi-paranjpe-nbt',
  },
  {
    title: 'عقل مند اور چالاک',
    author: 'کالا تھارانی',
    src: 'https://archive.org/embed/akalmand-aur-chalak-kala-tharani-nbt',
  },
  {
    title: 'تین بھالو',
    author: 'ٹالسٹائی',
    src: 'https://archive.org/embed/teen-bhalu-urdu-tolstoy',
  },
  {
    title: 'میں بنا سکتا ہوں',
    author: 'منی سرینی واسن',
    src: 'https://archive.org/embed/56547-mein-bana-sakta-hun',
  },
  {
    title: 'سنو کہانی',
    author: 'منصور نقوی',
    src: 'https://archive.org/embed/suno-kahani-mansoor-naqvi',
  },
  {
    title: 'انوکھی دکان',
    author: 'NBT',
    src: 'https://archive.org/embed/AnuthiDukan-Urdu-ChildrensBook',
  },
  {
    title: 'اڑنے والا گینڈا',
    author: 'منور جعفٰی',
    src: 'https://archive.org/embed/udne-vala-genda-munawwar-jafa',
  },
  {
    title: 'ڈھولک',
    author: 'پروین سید',
    src: 'https://archive.org/embed/225332-dholak',
  },
];

export default function Kitabain() {
  const [selectedBook, setSelectedBook] = useState(null);

  return (
    <div className="kitabain-page">
      <h1 className="kitabain-title">کتابیں</h1>

      <div className="kitabain-grid">
        {books.map((book, index) => (
          <div
            key={index}
            onClick={() => setSelectedBook(book)}
            className="kitabain-book-card"
          >
            <iframe
              src={book.src}
              width="100%"
              height="180"
              title={book.title}
              className="kitabain-book-iframe"
            ></iframe>
            <div className="kitabain-book-title">{book.title}</div>
            <div className="kitabain-book-author">{book.author}</div>
          </div>
        ))}
      </div>

      {selectedBook && (
        <div
          onClick={() => setSelectedBook(null)}
          className="overlay kitabain-overlay"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="kitabain-modal"
          >
            <div className="kitabain-modal-header">
              {selectedBook.title}
            </div>
            <iframe
              src={selectedBook.src}
              className="kitabain-modal-iframe"
              allowFullScreen
              title={selectedBook.title}
            ></iframe>
            <button
              onClick={() => setSelectedBook(null)}
              className="kitabain-modal-close"
            >
              بند کریں
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
